// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/icons/wait.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/gif;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/emoticons/warning.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQCAYAAAAiYZ4HAAAABGdBTUEAALGPC/xhBQAAARBJREFUKBV9kbuuRUAUhteISyVRaBQUKu//KhoitBKFEBTitv3rnCWzx8mZZFxmvv8y0PXHOI7jKsvyGobhtWuRMc7zpKqqaJomquuaxnH8Ir4EAs/zTEopuu1fokegw47jUJqmFATBS6RQ0oSTJCHXdblK27Z0n4UTYaL6vr+6riPUgLMOS3ldZDdNw+smbFk/bZEeRREzSLJ936d1XSmO46cGYNu2Gdr3nXSRWpblkmjcBS6KgpezLCMR8T4+Hya//DoDRiomnpEmFS18a0zdGaDneTxNkdq27akkzoBRBcNcewTmhn5ofU/lec4JUgPOAnPEfcGhRWQB/A+GCAYwQlV1/0VOCMPw5SwJckfSB4/U/WAIKs/PAAAAAElFTkSuQmCC", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comment-thread .quick-comment-container {
	min-height: 268px;
}

body.contenteditor {
	/* Have to stop dialog2 from clobbering the overflow on the body element. //ecosystem.atlassian.net/browse/AUI-4087 */
	overflow: hidden !important;
	overflow-y: auto !important;
	/*
     * CONFDEV-26898 - ensure that any fullscreen iframes added by plugins (e.g. when editing
     * a Balsamiq mockup) appear above positioned elements of the editor such as the page title,
     * breadcrumbs, and error messages.
     *
     * Any iframes that have an explicit z-index should be able to easily override this value
     * with a more specific selector.
     */
}

body.contenteditor ~ iframe {
	z-index: 4;
}

.contenteditor #full-height-container,
.contenteditor #main .edit form {
	display: table;
}

.contenteditor #full-height-container > div,
.contenteditor #full-height-container > main,
.contenteditor #editpagetemplate > div,
.contenteditor #createpagetemplate > div,
.contenteditor #editpageform > div,
.contenteditor #createpageform > div {
	display: table-row;
	padding: 0;
}

.contenteditor #full-height-container.active-preview #main-header,
.contenteditor #full-height-container #content > .aui-message {
	display: none;
}

.contenteditor #full-height-container > div,
.contenteditor #main .edit form {
	width: 100%;
}

.contenteditor #main,
#content.edit,
.contenteditor #main .edit form,
#wysiwyg,
#preview,
#previewArea {
	height: 100%;
	/*CONF-41035*/
}

#content.edit {
	display: table-cell;
}

.contenteditor #header-precursor > div,
.contenteditor .cell {
	display: table-cell;
	/* Needed to ensure that elements will appear below it when scrolling */
}

.contenteditor #header-precursor,
.contenteditor #header-precursor .cell {
	z-index: 3;
	position: relative;
	background: var(--ds-surface, #ffffff);
}

#main.active-preview .edit + br.clear {
	display: none;
}

.contenteditor #header .cell,
.contenteditor #header-precursor .cell {
	box-sizing: border-box;
	padding: 0 0.75em;
}

.contenteditor #main {
	border: 0 !important;
}

#wysiwyg iframe,
#preview iframe {
	height: 100%;
	width: 100%;
	border: 0;
	padding: 0;
	margin: 0;
}

.grouped ul,
.grouped ol {
	margin: 0;
	padding-left: 0;
}

.aui-toolbar .grouped .grouped-dropdown-item {
	background: transparent;
	border-top: 1px solid var(--ds-border, #ddd);
	margin-top: 3px;
	padding-top: 3px;
	padding-bottom: 3px;
	height: auto;
	clear: both;
}

.aui-toolbar .aui-dropdown.grouped .grouped-dropdown-item:hover,
.aui-toolbar .aui-dropdown.grouped .grouped-dropdown-item.active,
.aui-toolbar .aui-dropdown.grouped .grouped-dropdown-item.active a {
	background: transparent;
}

.aui-toolbar .grouped .grouped-dropdown-item:first-child {
	border-top: 0;
	padding-top: 0;
}

.grouped span {
	display: inline-block;
	padding: 0 0.5em;
	margin-top: 4px;
	/* avoid inappropriate hover effect */
}

.grouped .grouped-dropdown-item:hover,
.grouped .grouped-dropdown-item.active {
	background: transparent;
	/* END exploratory pattern for grouped dropdowns */
	/* CSS from here on is implementation-specific */
}

#rte-savebar .loading {
	background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_0___}) 50% 50% no-repeat;
	text-indent: -9999px;
	overflow: hidden;
	width: 25px;
	height: 25px;
	visibility: hidden;
	/* hidden, but affecting layout by default. js handles further show/hide */
	/* Source editor styles */
}

#editor-html-source {
	border: none;
	overflow-y: hidden;
	width: 100%;
	height: 100%;
}

#editor-html-source-container {
	margin-bottom: 40px;
	/* Editor toolbar and icons */
	/* TODOXHTML look at this stuff again    */
}

#previewArea iframe {
	border: none;
	margin: 0;
	width: 100%;
	overflow-x: hidden;
}

.comment #previewArea {
	padding: 1px;
}

.comment #previewArea iframe {
	overflow: hidden;
}

#rte-toolbar {
	font-size: 0;
	width: 100%;
	line-height: 1;
	border-bottom: 1px solid var(--ds-border, #ccc);
	margin: 0;
	padding: 0;
	background-color: var(--ds-surface-sunken, #f5f5f5);
	padding-top: 7px;
}

#rte-toolbar .aui-buttons {
	border-left: 1px solid var(--ds-border, #cccccc);
	padding-left: 3px;
	margin-left: 0;
}

body[data-aui-version='6.1.4-SNAPSHOT'] #rte-toolbar .aui-buttons .aui-button ~ .aui-button:active,
body[data-aui-version='6.1.4-SNAPSHOT'] #rte-toolbar .aui-buttons .aui-button ~ .aui-button:focus {
	margin-left: 0;
}

.contenteditor #rte-toolbar {
	z-index: 2;
	position: relative;
}

#rte-toolbar .aui-toolbar2-primary {
	margin: 0 114px 0 10px;
}

.contenteditor #rte-toolbar .aui-toolbar2-primary {
	margin-right: 16px;
}

#toolbar #rte-toolbar .aui-buttons {
	margin-right: 3px;
}

#toolbar .aui-buttons + .aui-buttons {
	margin-left: 0;
}

#toolbar #rte-toolbar .aui-toolbar2-primary .aui-buttons.no-separator {
	margin-right: 2px;
	margin-left: -2px;
}

#rte-toolbar .aui-toolbar2-secondary .aui-buttons,
#rte-toolbar .aui-buttons.no-separator,
#rte-toolbar .aui-buttons:first-child,
#rte-toolbar .aui-buttons.close {
	border-left: none;
	padding-left: 0;
}

#rte-toolbar .disabled,
#rte-toolbar .toolbar-contextual.disabled,
#rte-toolbar .toolbar-item.disabled,
#rte-toolbar-row-default .aui-button[disabled] .icon {
	color: var(--ds-icon-disabled, #707070);
	opacity: 0.5;
	cursor: not-allowed;
}

#rte-toolbar .disabled a,
#rte-toolbar .disabled span,
#rte-toolbar .disabled button,
#rte-toolbar .disabled div,
#rte-toolbar .disabled li {
	cursor: not-allowed !important;
	/* When toolbar is disabled jquery.fadeTo(0.5) is executed. This ensures the [disabled]
     icons don't compound the opacity changes */
}

#rte-toolbar-row-default.disabled .aui-button[disabled] .icon {
	opacity: 1;
}

#rte-savebar {
	display: block;
	margin: 0;
	border-top: 1px solid var(--ds-border, #ccc);
	background-color: var(--ds-surface-sunken, #f5f5f5);
	padding: 5px 10px 0px 0;
	box-shadow: none;
}

#rte-savebar #rte-spinner {
	width: 16px;
	height: 18px;
	line-height: 20px;
	padding: 0;
	margin-top: 4px;
}

#rte-savebar .minor-edit label {
	color: var(--ds-text, #000);
	font-weight: normal;
}

#rte-savebar #rte-button-cancel:not(.rte-button-cancel-shared-drafts),
#rte-savebar #rte-button-revert {
	border: 0;
	padding: 1px;
	padding-right: 0;
}

#rte-savebar .toolbar-split-row {
	font-size: 11px;
	color: var(--ds-text-subtle, #666);
	margin: 0;
}

#rte-savebar label {
	font-size: 14px;
	margin-right: 5px;
	line-height: 30px;
}

#rte-savebar .aui-buttons {
	margin-right: 10px;
	margin-left: 0;
}

#rte-savebar .save-button-container {
	float: left;
	white-space: nowrap;
	padding-left: 0;
	margin-right: 10px;
}

#rte-savebar .aui-icon-wait {
	/* text wrapper for spinner */
	background-repeat: no-repeat;
	background-position: 0 3px;
	display: block;
}

#rte-savebar .toolbar-split {
	line-height: 1;
}

#rte-savebar .hints {
	margin-bottom: 0;
}

#rte-savebar .minor-edit,
#rte-savebar .rte-toolbar-comment {
	padding: 0;
}

#rte-savebar .minor-edit {
	margin-top: 1px;
}

#rte-savebar-tinymce-plugin-point {
	font-size: 14px;
	float: left;
}

#rte-savebar-tinymce-plugin-point .toolbar-item {
	float: none;
	margin-left: 10px;
}

#rte-savebar .minor-edit input,
#versionComment {
	position: relative;
}

#rte-toolbar .toolbar-contextual {
	display: block;
	background-color: var(--ds-surface-sunken, #f5f5f5);
}

#toolbar #rte-toolbar .toolbar-contextual .aui-buttons.close .icon-close {
	height: 16px;
	width: 16px;
}

#rte-toolbar .toolbar-contextual .aui-buttons.close .aui-button {
	border: 0;
	background: transparent;
	box-shadow: none;
	padding: 0;
}

#rte-toolbar .aui-toolbar2-secondary ul.aui-buttons:last-child {
	margin-right: 0;
}

#rte-button-insert-table:focus {
	outline: none;
}

#rte-button-insert-table,
#rte-button-insert,
#rte-button-insert-template {
	padding: 0 10px;
}

#toolbar-group-watch-page-after-comment {
	margin: 0;
	/* Remove the margin here so we can use line height to position it. */
}

#rte-button-preview,
#rte-button-publish,
#rte-button-cancel,
#rte-button-edit {
	line-height: 20px;
}

#rte-button-preview,
#rte-button-cancel.rte-button-cancel-shared-drafts,
#rte-button-edit {
	min-width: 72px;
}

#rte-button-preview.rte-button-preview-shared-drafts {
	min-width: inherit;
}

#rte-button-cancel.rte-button-cancel-shared-drafts {
	padding: 4px 10px;
}

#rte-toolbar-row-searchreplace {
	padding: 3px 0 0 10px;
	margin-left: 0;
	display: block;
}

#toolbar #rte-toolbar-row-searchreplace.toolbar-contextual .aui-buttons {
	margin-left: 0;
	margin-right: 3px;
}

#toolbar #rte-toolbar-row-searchreplace.toolbar-contextual .aui-buttons.no-separator {
	margin-left: 10px;
}

#rte-toolbar-row-searchreplace .toolbar-group label {
	margin-right: 4px;
	margin-left: 10px;
	font-size: 14px;
}

#rte-toolbar-row-searchreplace .aui-buttons .toolbar-item > label {
	line-height: 20px;
	font-size: 14px;
	margin-left: 20px;
	margin-right: 10px;
}

#rte-toolbar-row-searchreplace .aui-buttons .toolbar-item:first-child > label {
	margin-left: 0;
}

#rte-toolbar-row-searchreplace .aui-buttons .toolbar-item > input {
	width: auto;
}

#search-toolbar-replace-text {
	margin-right: 10px;
}

#rte-toolbar .toolbar-splitbutton .aui-dd-parent .aui-dd-trigger {
	padding: 0 2px;
}

#rte-toolbar .toolbar-splitbutton .aui-dd-parent .aui-dd-trigger {
	padding: 0 2px;
	/* partition off a tiny space in the top right of the toolbar to place the help button group */
	/* This overrides the toolbar split style in AUI 3.2.1 */
}

#rte-toolbar .toolbar-split-right {
	float: none;
	position: absolute;
	right: 0;
	top: 10px;
	max-width: 80px;
}

#rte-toolbar .toolbar-split-left {
	margin-right: 80px;
}

#savebar-container ul li.toolbar-item {
	text-align: center;
	/* Required for button alignment in IE */
	/* Full screen editor styles */
}

.editor-fullheight {
	height: 100%;
	/* CONF-28415 */
}

#wysiwyg .mceIframeContainer,
#wysiwyg table.mceLayout {
	border: 0;
	/* Set dropdown links to block to make them full width */
}

#toolbar .aui-dropdown a {
	display: block;
	/* TODOXHTML: change vms so this stuff simply isn't rendered on edit screen. */
}

body.contenteditor #footer,
body.contenteditor #sidebar-container {
	display: none;
}

#draft-status {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	color: var(--ds-text-subtle, #707070);
	font-size: 12px;
	line-height: 12px;
	padding: 8px 0 0 10px;
	max-width: 240px;
}

#draft-status a:hover,
#draft-status a:active,
#draft-status a:visited,
#draft-status a:link {
	color: var(--ds-link-pressed, #707070);
	/* RTE hints and hint buttons */
}

.hints a:hover,
.hints a:active,
.hints a:visited,
.hints a:link {
	text-decoration: none;
	outline: none;
}

.hints {
	margin: 0 0 10px 0;
	/* Confluence RTE Toolbar Icons */
}

#rte-button-color {
	border-right: 0;
	margin-right: 0;
	-moz-border-radius: 3px 0 0 3px;
	-webkit-border-radius: 3px 0 0 3px;
	border-radius: 3px 0 0 3px;
}

#rte-button-color .selected-color {
	background: var(--ds-surface, #fff);
	border: 1px solid var(--ds-border-selected, #ddd);
	border-radius: 2px;
	width: 14px;
	height: 2px;
	margin: 18px 0 0 0;
	display: block;
}

#rte-button-color .selected-color span {
	width: 14px;
	height: 2px;
	margin: 0;
	padding: 0;
}

#rte-button-color .icon-textcolor {
	margin-top: 2px;
	/* adjust padding to let the dropdown menus breathe */
}

#format-dropdown #format-dropdown-display {
	padding: 0 10px 0 10px;
}

#format-dropdown #format-dropdown-display span.dropdown-text {
	font-size: 12px;
	min-width: 70px;
	/* covers maximum expected i18n text width to avoid drop down flickering */
}

#format-dropdown .aui-dropdown li {
	height: auto;
	padding: 0;
}

#format-dropdown .aui-dropdown a {
	padding: 6px 50px 6px 10px;
}

#format-dropdown .aui-dropdown .mce_h1 a,
#format-dropdown .aui-dropdown .mce_h2 a,
#format-dropdown .aui-dropdown .mce_h3 a,
#format-dropdown .aui-dropdown .mce_h4 a {
	padding: 0.4em 50px 0.5em 10px;
}

#insert-menu .aui-dropdown .icon {
	background-position: 0 0;
	background-repeat: no-repeat;
	background-color: transparent;
	display: inline-block;
	height: 16px;
	padding: 0;
	margin: 1px 4px 0 0;
	text-indent: -9999em;
	width: 16px;
}

#pagelayout-menu .aui-dropdown a,
#more-menu .aui-dropdown a,
#insert-menu .aui-dropdown a,
#template-menu .aui-dropdown a {
	line-height: 19px;
}

#more-menu .aui-dropdown a {
	padding: 4px 50px 4px 25px;
}

#template-menu .aui-dropdown a {
	padding: 6px 50px 6px 10px;
}

#insert-menu .aui-dropdown a {
	padding: 4px 50px 4px 8px;
	margin: 0;
}

#more-menu .no-icon .icon {
	margin: 0;
}

#pagelayout-menu .aui-dropdown {
	min-width: 0;
}

#pagelayout-menu .aui-dropdown a {
	min-width: 0;
	padding: 2px 10px 2px 25px;
}

#pagelayout-menu .aui-dropdown li:first-child {
	padding-top: 5px;
}

#pagelayout-menu .aui-dropdown li:last-child {
	padding-bottom: 5px;
}

#pagelayout-menu .aui-dropdown .icon {
	/* pagelayout specific styles */
	padding-left: 0;
}

#pagelayout-menu .aui-dropdown .icon-layout {
	float: none;
	display: block;
	/* icon-only buttons */
}

.aui-toolbar .icon {
	text-indent: -9999em;
	width: 16px;
	float: left;
	height: 100%;
	display: inline-block;
	background: transparent 0 0 no-repeat;
}

#rte-savebar .aui-button-primary {
	padding: 4px 10px;
}

#rte-toolbar .aui-button .dropdown-text {
	float: left;
	/* genuine AUI override */
}

.aui-toolbar .aui-dd-parent .aui-dropdown li {
	padding: 0;
	/* overriding an AUI override until we can remove the override. no, really. */
}

body .aui-toolbar .aui-dd-parent .aui-dropdown li a {
	color: var(--ds-text, #333);
	padding: 4px 10px;
	/* TODOXHTML should probably get better consideration */
}

.aui-toolbar .aui-dd-parent .aui-dropdown li a:link {
	color: var(--ds-link, #333);
}

.aui-toolbar .aui-dd-parent .aui-dropdown li a:focus,
.aui-toolbar .aui-dd-parent .aui-dropdown li a:hover,
.aui-toolbar .aui-dd-parent .aui-dropdown li a:active,
.aui-toolbar .aui-dd-parent .aui-dropdown li.active {
	background-color: var(--ds-surface-hovered, #f2f2f2);
	color: var(--ds-text, #333);
	/* end override */
}

form.aui.editor {
	margin-top: 0px;
	/* TODOXHTML: remove the original competing style */
}

#format-dropdown li.mce_formatPreview.mce_blockquote a {
	border-left: 0;
	/* Title styles */
}

#editor-precursor {
	background-color: var(--ds-surface-hovered, #f5f5f5);
}

#editor-precursor .cell {
	display: block;
	padding-bottom: 10px;
	width: 100%;
	position: relative;
}

.active-preview #editor-precursor .cell {
	border-bottom: 1px dashed transparent;
}

#editor-precursor #breadcrumbs {
	padding-left: 10px;
	display: inline-block;
	margin-top: 20px;
	margin-bottom: 10px;
}

#editor-precursor #draft-status-lozenge {
	position: relative;
	top: -3px;
	text-decoration: none;
}

#editor-precursor #editor-messages {
	margin: 0 10px;
	/* CONF-32021 Remove aui style causing editor messages to appear too close to the page title input field */
}

#editor-precursor .aui-message:first-child {
	margin-top: 10px;
}

#content-title {
	max-width: 100%;
	margin: 0;
	min-height: 32px;
	line-height: 30px;
	padding: 0;
	outline: none;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	background: none;
	border: none !important;
	/* Applying !important to beat an AUI override that is necessary for overriding Spinner2 (3rd party) border */
	box-shadow: none;
	display: inline-block;
	font-size: 28px;
	height: 32px;
	width: 100%;
	/* placeholder styles, don't group them */
}

#content-title::-webkit-input-placeholder {
	color: var(--ds-text, #999999);
}

#content-title:-moz-placeholder {
	color: var(--ds-text, #999999);
}

#content-title::-moz-placeholder {
	color: var(--ds-text, #999999);
}

#content-title:-ms-input-placeholder {
	color: var(--ds-text, #999999);
}

#content-title-div {
	padding: 0px 30px 0 10px;
	font-size: 24px;
	line-height: normal;
	font-weight: bold;
	margin-top: 0px;
}

#content-title-div .field-group {
	padding: 0;
}

#content-title-div .error {
	/* We need to sytle it as it's not in an AUI form */
	font-weight: bold;
	color: var(--ds-text-danger, #cc0000);
	background-color: var(--ds-surface, #fff);
	padding-top: 5px;
}

.editor.aui #all-messages {
	padding: 0 10px 0 10px;
}

.contenteditor #main-header,
#comments-section #editor-precursor,
#comments-section #editor-notifications-container,
#main.active-preview.active-preview #editor-notifications-container,
#main.active-preview #editor-messages,
#main.active-preview #editpageform > div#toolbar,
#main.active-preview #content-title-div {
	display: none;
}

.contenteditor .active-preview #main-header {
	display: block;
}

.quick-comment-container #editor-messages .aui-message.error {
	margin: 0 0 10px 0;
}

#editor-notification-container {
	display: table-row;
	position: absolute;
	bottom: 100px;
	right: 25px;
	width: 300px;
	z-index: 5;
}

.contenteditor #editor-notifications-container {
	left: 0;
	margin: 0 auto;
	max-width: 880px;
	position: absolute;
	right: 0;
	top: 10px;
	width: 100%;
	z-index: 2;
}

.contenteditor #full-height-container.active-preview .aui-message {
	margin: 20px 20px 0 20px;
}

.contenteditor #editor-notifications-container #all-messages,
.contenteditor #editor-notifications-container #heartbeat-div,
.contenteditor #editor-notifications-container #editor-messages {
	width: 100%;
	padding: 0;
}

.contenteditor #editor-notifications-container #all-messages .aui-message,
.contenteditor #editor-notifications-container #heartbeat-div .aui-message,
.contenteditor #editor-notifications-container #editor-messages .aui-message {
	margin: 10px 0px;
	-webkit-box-shadow: var(--ds-shadow-raised, 0px 3px 6px 0px rgba(0, 0, 0, 0.2));
	-moz-box-shadow: var(--ds-shadow-raised, 0px 3px 6px 0px rgba(0, 0, 0, 0.2));
	box-shadow: var(--ds-shadow-raised, 0px 3px 6px 0px rgba(0, 0, 0, 0.2));
}

.contenteditor #editor-precursor {
	position: absolute;
	z-index: 1;
	width: 100%;
	background: none;
	padding: 0px;
}

#toolbar #more-menu .dd-allocated,
#toolbar #more-menu .dd-allocated .aui-button {
	margin-left: 0;
}

.aui-toolbar .toolbar-split-captcha .toolbar-group {
	float: right;
}

.aui-toolbar .captcha {
	padding: 0;
	width: auto;
	text-align: right;
}

.aui-toolbar .captcha .aui-message-warning,
.aui-toolbar #captcha-response {
	clear: both;
}

.aui-toolbar .captcha-image {
	margin: 7px 3px;
}

.aui-toolbar .captcha-image,
.aui-toolbar #captcha-response {
	float: right;
}

#rte-toolbar li.disabled:not(.active),
#rte-toolbar button.disabled:not(.active),
#rte-toolbar .disabled:focus button:not(.active),
#rte-toolbar .disabled:hover button:not(.active),
#rte-toolbar .disabled:active button:not(.active),
#rte-toolbar .disabled:focus a:not(.active),
#rte-toolbar .disabled:hover a:not(.active),
#rte-toolbar .disabled:active a:not(.active) {
	box-shadow: none !important;
	background: none !important;
	border-color: transparent !important;
	/* CONFDEV-4468 - Copied from tiny_mce/themes/advanced/skins/default/ui.css */
}

#wysiwyg .defaultSkin .mceBlocker {
	position: absolute;
	left: 0;
	top: 0;
	z-index: 1000;
	opacity: 0.5;
	-ms-filter: 'alpha(opacity=50)';
	filter: alpha(opacity=50);
	background: var(--ds-surface, #fff);
}

#wysiwyg .defaultSkin .mceProgress {
	position: absolute;
	left: 0;
	top: 0;
	z-index: 1001;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
		top left no-repeat;
	width: 32px;
	height: 32px;
	margin: -16px 0 0 -16px;
	/* Table Picker */
}

#table-picker-container .table-picker-box {
	overflow: hidden;
	border: 1px solid var(--ds-border, #ccc);
	padding: 6px;
	background-color: var(--ds-surface, #fff);
	cursor: pointer;
}

#table-picker-container .table-picker-background {
	position: relative;
}

#table-picker-container .picker {
	overflow: hidden;
	background-repeat: repeat;
	position: absolute;
}

#table-picker-container .picker.heading {
	height: 18px;
}

#table-picker-container .table-picker-box .desc {
	overflow: hidden;
	font-family: helvetica;
	font-size: 12px;
	display: block;
	text-align: center;
	font-weight: bold;
	width: 100%;
	margin: 0;
	position: absolute;
	bottom: 0;
	left: 0;
	height: 20px;
}

#table-picker-container {
	position: absolute;
	z-index: 10001;
}

#table-picker-backdrop {
	background-color: transparent;
	position: fixed;
	padding: 0;
	margin: 0;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 10000;
}

#conflict-diffs {
	display: table-cell;
	border-top: 1px solid var(--ds-border, #ccc);
	border-bottom: 1px solid var(--ds-border, #ccc);
}

#conflict-wrapper {
	max-height: 300px;
	overflow: auto;
}

#conflict-wrapper > .aui-message {
	margin: 10px;
}

#page-diffs {
	margin: 0 10px;
	padding: 10px 0;
}

#confluence-editor-discard-confirm-dialog .confluence-editor-discard-message span {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
	background-position: 0.5em 50%;
	background-repeat: no-repeat;
	margin: 0px;
	padding-left: 28px;
	padding-top: 0px;
	/* from master.css */
}

.hidden,
li.hidden {
	display: none !important;
	visibility: hidden;
}

#page {
	width: 100%;
	height: 100%;
	margin: 0;
	padding: 0;
	/* End from master.css */
	/* from default-theme.css */
}

html,
body {
	height: 100%;
}

#full-height-container {
	height: 100%;
	width: 100%;
	position: relative;
}

#full-height-container.active-preview {
	background-color: var(--ds-surface, #ffffff);
	/* End from default-theme.css */
	/* custom overrides for PDL */
}

#toolbar .aui-toolbar2-secondary {
	margin-right: -6px;
}

#toolbar .aui-toolbar2-secondary .aui-button {
	padding: 0 6px;
}

.aui-toolbar2 {
	box-sizing: border-box;
}

.aui-toolbar2 .aui-toolbar2-primary {
	float: left;
}

.aui-toolbar2 .aui-toolbar2-secondary {
	position: absolute;
	top: 7px;
	right: 10px;
}

.aui-toolbar2 .toolbar-dropdown .icon-dropdown {
	height: 100%;
}

.aui-toolbar2 .aui-dd-parent > a.toolbar-trigger.aui-dd-trigger {
	position: relative;
	height: 26px;
	line-height: 24px;
	font-size: 12px;
	border-top-right-radius: 3px;
	border-bottom-right-radius: 3px;
	text-shadow: none;
	text-decoration: none;
	/* dropdown arrow */
}

.aui-toolbar2 .aui-dd-parent > a.toolbar-trigger.aui-dd-trigger:after {
	border: 4px solid transparent;
	content: '';
	height: 0;
	left: 100%;
	/* "left" + "margin-left" required because of webkit not working properly with "right" */
	margin-left: -18px;
	margin-top: -1px;
	opacity: 0.8;
	position: absolute;
	top: 50%;
	width: 0;
	border-top-color: var(--ds-border, #333);
	/* Following rules target Insert table and Insert More styles */
}

#toolbar .aui-toolbar2 .aui-buttons.no-separator .aui-dd-parent > a.aui-dd-trigger {
	padding-right: 5px;
}

#toolbar .aui-toolbar2 .aui-buttons.no-separator .aui-dd-parent > a.aui-dd-trigger:after {
	margin-left: -15px;
}

.aui-toolbar2 .aui-dd-parent > a.aui-dd-trigger:hover:after {
	opacity: 1;
}

.aui-toolbar2 .aui-dd-parent > a.aui-dd-trigger:active,
.aui-toolbar2 .toolbar-dropdown.active .aui-dd-parent > a.aui-dd-trigger,
.aui-toolbar2 .aui-dd-parent.active > a.aui-dd-trigger {
	background-image: none;
	background-color: var(--ds-background-input-pressed, #f2f2f2);
	box-shadow: var(--ds-shadow-raised, inset 0 3px 6px rgba(0, 0, 0, 0.1));
	text-shadow: none;
	text-decoration: none;
	/*
     Ideally can remove these overrides when this issue is resolved
     https://ecosystem.atlassian.net/browse/AUI-949
     */
}

.aui-toolbar2 .aui-dropdown,
body.edit .aui-dialog .aui-dropdown,
body.create .aui-dialog .aui-dropdown {
	background-color: var(--ds-surface, #fff);
	border: 1px solid var(--ds-border, #ccc);
	border-bottom-left-radius: 3px;
	border-bottom-right-radius: 3px;
	box-shadow: var(--ds-shadow-raised, 0 3px 6px rgba(0, 0, 0, 0.2));
}

.aui-toolbar2 .aui-dropdown a.item-link,
.aui-toolbar2
	.aui-dropdown
	a.item-link:focus
	.aui-toolbar2
	.aui-dropdown
	a.item-link:hover
	.aui-toolbar2
	.aui-dropdown
	a.item-link:active {
	text-decoration: none;
	font-size: 14px;
}

.aui-buttons li.toolbar-dropdown:first-child {
	border-top-left-radius: 3px;
	border-bottom-left-radius: 3px;
	border-left-width: 1px;
	border-left-color: var(--ds-border-bold, #ccc);
}

#rte-toolbar .toolbar-item,
#rte-toolbar .toolbar-item > a.toolbar-trigger {
	height: 26px;
}

#rte-toolbar .toolbar-item:link,
#rte-toolbar .toolbar-item > a.toolbar-trigger:link,
#rte-toolbar .toolbar-item:visited,
#rte-toolbar .toolbar-item > a.toolbar-trigger:visited,
#rte-toolbar .toolbar-item:hover,
#rte-toolbar .toolbar-item > a.toolbar-trigger:hover,
#rte-toolbar .toolbar-item:focus,
#rte-toolbar .toolbar-item > a.toolbar-trigger:focus,
#rte-toolbar .toolbar-item:active,
#rte-toolbar .toolbar-item > a.toolbar-trigger:active {
	text-decoration: none;
	color: var(--ds-text, #333);
}

.aui-toolbar2 li.aui-button {
	display: inline-block;
	padding: 0 10px;
	float: none;
	line-height: 30px;
}

.aui-toolbar2 li.aui-button a.toolbar-trigger {
	padding: 0;
	margin: 0;
}

#format-dropdown-display-menu li > a {
	margin-left: 2px;
}

#table-more-settings h2 {
	padding-bottom: 10px;
}

#rte-savebar .aui-button-link:hover {
	text-decoration: none;
}

#rte-savebar .aui-button span.icon ~ span.trigger-text,
#rte-toolbar .aui-button span.icon ~ span.trigger-text,
#rte-toolbar .aui-button span.icon ~ span.dropdown-text,
#property-panel .aui-button span.icon ~ span.panel-button-text {
	padding-left: 3px;
}

#rte-toolbar .aui-button,
#rte-savebar .aui-button {
	margin-top: 0;
}

#rte-savebar.aui-toolbar2 .aui-button {
	margin-top: 0px;
}

#editor-precursor .aui-toolbar2 .aui-button {
	padding: 0 6px;
}

#editor-precursor .aui-toolbar2 {
	padding-left: 10px;
}

.aui-page-panel.active-preview #editor-precursor .aui-toolbar2 {
	/* Here we hide the breadcrumb buttons when in the editor preview mode. */
	display: none;
}

.aui-message .aui-icon {
	background-position: center;
}

#rte-toolbar input,
#rte-savebar input,
#update-page-restrictions-dialog input {
	font-size: 14px;
}

#rte-toolbar-row-searchreplace .aui-buttons {
	margin-top: 0;
}

#rte-toolbar .aui-dropdown {
	z-index: 4001;
	/* Higher than property panels */
	/* End custom overrides for PDL */
	/* These containers need to be positioned above the page title and breadcrumbs in the editor,
     so that they don't re-appear above the global header as the editor content is scrolled */
}

#editpageform > #anonymous-warning {
	display: none;
}

#comments-section #anonymous-warning {
	margin-top: 0;
	margin-bottom: 10px;
}

.contenteditor #pas-announcement {
	display: block;
	position: relative;
	opacity: 1;
}

.contenteditor #header {
	z-index: 3;
	position: relative;
}

.contenteditor #conflict-diffs {
	z-index: 2;
	position: relative;
	background: var(--ds-surface, #ffffff);
}

#rte-toolbar {
	/*Relative resize table*/
}

#rte-toolbar ul.table-mode-list {
	list-style: none;
	margin: 0;
	padding: 5px 0;
}

#rte-toolbar ul.table-mode-list .item-link {
	padding-right: 20px;
}

#rte-toolbar ul.table-mode-list .dropdown-item {
	line-height: 18px;
}

#table-mode-picker a.toolbar-trigger.aui-button {
	padding: 0 10px;
	color: var(--ds-text, #333);
}

#table-mode-picker.active .toolbar-trigger.aui-button {
	border-color: var(--ds-border, #ccc);
}

.quit-editor-dialog .tipsy-inner {
	text-align: left;
	max-width: 220px;
}

#quit-editor-dialog button.disabled {
	text-decoration: none;
	outline: none;
}

#quit-editor-dialog .legend {
	margin-bottom: 15px;
}

#quit-editor-dialog .legend .legend-title {
	font-weight: bold;
}

#quit-editor-dialog .legend span {
	padding: 5px;
}

#quit-editor-dialog .diff-context-placeholder {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_3___})
		repeat-x;
	background-size: 6px;
	height: 10px;
}

#quit-editor-dialog .aui-button {
	display: none;
}

#quit-editor-dialog .contributor-list {
	list-style: none;
	padding-left: 0px;
	margin-top: 13px;
	max-height: 160px;
	overflow-y: auto;
}

#quit-editor-dialog .contributor-list li {
	float: left;
	width: 50%;
}

#quit-editor-dialog .contributor-avatar {
	display: table-cell;
	vertical-align: middle;
	padding: 4px 0;
}

#quit-editor-dialog .contributor-avatar img {
	border-radius: 3px;
	height: 32px;
}

#quit-editor-dialog .contributor-avatar:not(.active) {
	-webkit-filter: grayscale(100%);
	filter: grayscale(100%);
	opacity: 0.7;
}

#quit-editor-dialog .contributor-name {
	padding: 0 10px;
	font-weight: bold;
	display: table-cell;
	vertical-align: middle;
}

#quit-editor-dialog .contributor-detail {
	display: table-cell;
	padding: 0 10px;
}

#quit-editor-dialog .contributor-detail-name {
	font-weight: bold;
	white-space: nowrap;
	text-overflow: ellipsis;
	display: block;
	width: 200px;
	overflow: hidden;
}

#quit-editor-dialog .contributor-detail-last-modification {
	display: inline-block;
	margin: 0;
	font-size: 13px;
	vertical-align: bottom;
	-webkit-filter: grayscale(100%);
	filter: grayscale(100%);
	opacity: 0.6;
}

.editor-block::after {
	background: var(--ds-background-neutral-subtle, #000);
	opacity: 0.5;
	content: '';
	position: absolute;
	top: 0;
	right: 0;
	left: 0;
	bottom: 0;
	z-index: 2;
}
`, "",{"version":3,"sources":["webpack://./../confluence-editor/src/adg3-styles/page-editor.css"],"names":[],"mappings":"AAAA;CACC,iBAAiB;AAClB;;AAEA;CACC,qHAAqH;CACrH,2BAA2B;CAC3B,2BAA2B;CAC3B;;;;;;;MAOK;AACN;;AAEA;CACC,UAAU;AACX;;AAEA;;CAEC,cAAc;AACf;;AAEA;;;;;;CAMC,kBAAkB;CAClB,UAAU;AACX;;AAEA;;CAEC,aAAa;AACd;;AAEA;;CAEC,WAAW;AACZ;;AAEA;;;;;;CAMC,YAAY;CACZ,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAEA;;CAEC,mBAAmB;CACnB,uEAAuE;AACxE;;AAEA;;CAEC,UAAU;CACV,kBAAkB;CAClB,sCAAsC;AACvC;;AAEA;CACC,aAAa;AACd;;AAEA;;CAEC,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;;CAEC,YAAY;CACZ,WAAW;CACX,SAAS;CACT,UAAU;CACV,SAAS;AACV;;AAEA;;CAEC,SAAS;CACT,eAAe;AAChB;;AAEA;CACC,uBAAuB;CACvB,4CAA4C;CAC5C,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,YAAY;CACZ,WAAW;AACZ;;AAEA;;;CAGC,uBAAuB;AACxB;;AAEA;CACC,aAAa;CACb,cAAc;AACf;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,eAAe;CACf,qCAAqC;AACtC;;AAEA;;CAEC,uBAAuB;CACvB,kDAAkD;CAClD,gDAAgD;AACjD;;AAEA;CACC,iFAAuE;CACvE,oBAAoB;CACpB,gBAAgB;CAChB,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,0EAA0E;CAC1E,yBAAyB;AAC1B;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,WAAW;CACX,YAAY;AACb;;AAEA;CACC,mBAAmB;CACnB,6BAA6B;CAC7B,0CAA0C;AAC3C;;AAEA;CACC,YAAY;CACZ,SAAS;CACT,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,cAAc;CACd,+CAA+C;CAC/C,SAAS;CACT,UAAU;CACV,mDAAmD;CACnD,gBAAgB;AACjB;;AAEA;CACC,gDAAgD;CAChD,iBAAiB;CACjB,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;CACC,UAAU;CACV,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;;;;CAIC,iBAAiB;CACjB,eAAe;AAChB;;AAEA;;;;CAIC,uCAAuC;CACvC,YAAY;CACZ,mBAAmB;AACpB;;AAEA;;;;;CAKC,8BAA8B;CAC9B;+CAC8C;AAC/C;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,cAAc;CACd,SAAS;CACT,4CAA4C;CAC5C,mDAAmD;CACnD,uBAAuB;CACvB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,UAAU;CACV,eAAe;AAChB;;AAEA;CACC,2BAA2B;CAC3B,mBAAmB;AACpB;;AAEA;;CAEC,SAAS;CACT,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,kCAAkC;CAClC,SAAS;AACV;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,WAAW;CACX,mBAAmB;CACnB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,6BAA6B;CAC7B,4BAA4B;CAC5B,0BAA0B;CAC1B,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;CAEC,UAAU;AACX;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;;CAEC,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,mDAAmD;AACpD;;AAEA;CACC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,SAAS;CACT,uBAAuB;CACvB,gBAAgB;CAChB,UAAU;AACX;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,aAAa;AACd;;AAEA;;;CAGC,eAAe;AAChB;;AAEA;CACC,SAAS;CACT,qEAAqE;AACtE;;AAEA;;;;CAIC,iBAAiB;AAClB;;AAEA;;;CAGC,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,qBAAqB;CACrB,cAAc;CACd,cAAc;AACf;;AAEA;CACC,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;CACjB,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,eAAe;CACf,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,8FAA8F;CAC9F,wDAAwD;AACzD;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,wCAAwC;CACxC,8BAA8B;AAC/B;;AAEA;CACC,YAAY;CACZ,eAAe;AAChB;;AAEA;;CAEC,SAAS;CACT,wDAAwD;AACzD;;AAEA;CACC,cAAc;CACd,8EAA8E;AAC/E;;AAEA;;CAEC,aAAa;AACd;;AAEA;CACC,gBAAgB;CAChB,uBAAuB;CACvB,mBAAmB;CACnB,qCAAqC;CACrC,eAAe;CACf,iBAAiB;CACjB,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;;;;CAIC,sCAAsC;CACtC,+BAA+B;AAChC;;AAEA;;;;CAIC,qBAAqB;CACrB,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,iCAAiC;AAClC;;AAEA;CACC,eAAe;CACf,eAAe;CACf,+BAA+B;CAC/B,kCAAkC;CAClC,0BAA0B;AAC3B;;AAEA;CACC,mCAAmC;CACnC,iDAAiD;CACjD,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,WAAW;CACX,WAAW;CACX,SAAS;CACT,UAAU;AACX;;AAEA;CACC,eAAe;CACf,qDAAqD;AACtD;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,eAAe;CACf,0EAA0E;AAC3E;;AAEA;CACC,YAAY;CACZ,UAAU;AACX;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;;;;CAIC,8BAA8B;AAC/B;;AAEA;CACC,wBAAwB;CACxB,4BAA4B;CAC5B,6BAA6B;CAC7B,qBAAqB;CACrB,YAAY;CACZ,UAAU;CACV,mBAAmB;CACnB,oBAAoB;CACpB,WAAW;AACZ;;AAEA;;;;CAIC,iBAAiB;AAClB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,yBAAyB;CACzB,SAAS;AACV;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,0BAA0B;AAC3B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,+BAA+B;CAC/B,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,cAAc;CACd,sBAAsB;AACvB;;AAEA;CACC,oBAAoB;CACpB,WAAW;CACX,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,qCAAqC;AACtC;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,yBAAyB;AAC1B;;AAEA;CACC,UAAU;CACV,6EAA6E;AAC9E;;AAEA;CACC,2BAA2B;CAC3B,iBAAiB;CACjB,uDAAuD;AACxD;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;;;;CAIC,oDAAoD;CACpD,2BAA2B;CAC3B,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,mDAAmD;AACpD;;AAEA;CACC,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,oDAAoD;AACrD;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,qBAAqB;AACtB;;AAEA;CACC,cAAc;CACd,0GAA0G;AAC3G;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,SAAS;CACT,gBAAgB;CAChB,iBAAiB;CACjB,UAAU;CACV,aAAa;CACb,gBAAgB;CAChB,uBAAuB;CACvB,mBAAmB;CACnB,gBAAgB;CAChB,uBAAuB;CACvB,6GAA6G;CAC7G,gBAAgB;CAChB,qBAAqB;CACrB,eAAe;CACf,YAAY;CACZ,WAAW;CACX,yCAAyC;AAC1C;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,wBAAwB;CACxB,eAAe;CACf,mBAAmB;CACnB,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,mDAAmD;CACnD,iBAAiB;CACjB,qCAAqC;CACrC,yCAAyC;CACzC,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;;;;;;;CAOC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,aAAa;CACb,WAAW;CACX,YAAY;CACZ,UAAU;AACX;;AAEA;CACC,OAAO;CACP,cAAc;CACd,gBAAgB;CAChB,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,WAAW;CACX,UAAU;AACX;;AAEA;CACC,wBAAwB;AACzB;;AAEA;;;CAGC,WAAW;CACX,UAAU;AACX;;AAEA;;;CAGC,gBAAgB;CAChB,+EAA+E;CAC/E,4EAA4E;CAC5E,uEAAuE;AACxE;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,gBAAgB;CAChB,YAAY;AACb;;AAEA;;CAEC,cAAc;AACf;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,UAAU;CACV,WAAW;CACX,iBAAiB;AAClB;;AAEA;;CAEC,WAAW;AACZ;;AAEA;CACC,eAAe;AAChB;;AAEA;;CAEC,YAAY;AACb;;AAEA;;;;;;;;CAQC,2BAA2B;CAC3B,2BAA2B;CAC3B,oCAAoC;CACpC,6EAA6E;AAC9E;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,aAAa;CACb,YAAY;CACZ,+BAA+B;CAC/B,yBAAyB;CACzB,mCAAmC;AACpC;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,aAAa;CACb;oBACmB;CACnB,WAAW;CACX,YAAY;CACZ,uBAAuB;CACvB,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,wCAAwC;CACxC,YAAY;CACZ,yCAAyC;CACzC,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,gBAAgB;CAChB,sBAAsB;CACtB,eAAe;CACf,cAAc;CACd,kBAAkB;CAClB,iBAAiB;CACjB,WAAW;CACX,SAAS;CACT,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,6BAA6B;CAC7B,eAAe;CACf,UAAU;CACV,SAAS;CACT,MAAM;CACN,SAAS;CACT,OAAO;CACP,QAAQ;CACR,cAAc;AACf;;AAEA;CACC,mBAAmB;CACnB,4CAA4C;CAC5C,+CAA+C;AAChD;;AAEA;CACC,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,yDAAsD;CACtD,8BAA8B;CAC9B,4BAA4B;CAC5B,WAAW;CACX,kBAAkB;CAClB,gBAAgB;CAChB,oBAAoB;AACrB;;AAEA;;CAEC,wBAAwB;CACxB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,SAAS;CACT,UAAU;CACV,wBAAwB;CACxB,2BAA2B;AAC5B;;AAEA;;CAEC,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,4CAA4C;CAC5C,+BAA+B;CAC/B,6BAA6B;AAC9B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,iBAAiB;CACjB,eAAe;CACf,4BAA4B;CAC5B,+BAA+B;CAC/B,iBAAiB;CACjB,qBAAqB;CACrB,mBAAmB;AACpB;;AAEA;CACC,6BAA6B;CAC7B,WAAW;CACX,SAAS;CACT,UAAU;CACV,wFAAwF;CACxF,kBAAkB;CAClB,gBAAgB;CAChB,YAAY;CACZ,kBAAkB;CAClB,QAAQ;CACR,QAAQ;CACR,wCAAwC;CACxC,+DAA+D;AAChE;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,UAAU;AACX;;AAEA;;;CAGC,sBAAsB;CACtB,6DAA6D;CAC7D,uEAAuE;CACvE,iBAAiB;CACjB,qBAAqB;CACrB;;;MAGK;AACN;;AAEA;;;CAGC,yCAAyC;CACzC,wCAAwC;CACxC,8BAA8B;CAC9B,+BAA+B;CAC/B,iEAAiE;AAClE;;AAEA;;;;;;;;;;CAUC,qBAAqB;CACrB,eAAe;AAChB;;AAEA;CACC,2BAA2B;CAC3B,8BAA8B;CAC9B,sBAAsB;CACtB,8CAA8C;AAC/C;;AAEA;;CAEC,YAAY;AACb;;AAEA;;;;;;;;;;CAUC,qBAAqB;CACrB,2BAA2B;AAC5B;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,UAAU;CACV,SAAS;AACV;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;;;;CAIC,iBAAiB;AAClB;;AAEA;;CAEC,aAAa;AACd;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,yEAAyE;CACzE,aAAa;AACd;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;;;CAGC,eAAe;AAChB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;CACb,gCAAgC;CAChC,iCAAiC;CACjC;6FAC4F;AAC7F;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,UAAU;CACV,kBAAkB;AACnB;;AAEA;CACC,UAAU;CACV,kBAAkB;CAClB,sCAAsC;AACvC;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,gBAAgB;CAChB,SAAS;CACT,cAAc;AACf;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,2BAA2B;AAC5B;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;CACrB,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC;UACS;CACT,oBAAoB;CACpB,YAAY;AACb;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,gBAAgB;CAChB,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,UAAU;AACX;;AAEA;CACC,mBAAmB;CACnB,sBAAsB;CACtB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,+BAA+B;CAC/B,uBAAuB;CACvB,YAAY;AACb;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;CACnB,uBAAuB;CACvB,cAAc;CACd,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;CACrB,SAAS;CACT,eAAe;CACf,sBAAsB;CACtB,+BAA+B;CAC/B,uBAAuB;CACvB,YAAY;AACb;;AAEA;CACC,qDAAqD;CACrD,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,MAAM;CACN,QAAQ;CACR,OAAO;CACP,SAAS;CACT,UAAU;AACX","sourcesContent":[".comment-thread .quick-comment-container {\n\tmin-height: 268px;\n}\n\nbody.contenteditor {\n\t/* Have to stop dialog2 from clobbering the overflow on the body element. //ecosystem.atlassian.net/browse/AUI-4087 */\n\toverflow: hidden !important;\n\toverflow-y: auto !important;\n\t/*\n     * CONFDEV-26898 - ensure that any fullscreen iframes added by plugins (e.g. when editing\n     * a Balsamiq mockup) appear above positioned elements of the editor such as the page title,\n     * breadcrumbs, and error messages.\n     *\n     * Any iframes that have an explicit z-index should be able to easily override this value\n     * with a more specific selector.\n     */\n}\n\nbody.contenteditor ~ iframe {\n\tz-index: 4;\n}\n\n.contenteditor #full-height-container,\n.contenteditor #main .edit form {\n\tdisplay: table;\n}\n\n.contenteditor #full-height-container > div,\n.contenteditor #full-height-container > main,\n.contenteditor #editpagetemplate > div,\n.contenteditor #createpagetemplate > div,\n.contenteditor #editpageform > div,\n.contenteditor #createpageform > div {\n\tdisplay: table-row;\n\tpadding: 0;\n}\n\n.contenteditor #full-height-container.active-preview #main-header,\n.contenteditor #full-height-container #content > .aui-message {\n\tdisplay: none;\n}\n\n.contenteditor #full-height-container > div,\n.contenteditor #main .edit form {\n\twidth: 100%;\n}\n\n.contenteditor #main,\n#content.edit,\n.contenteditor #main .edit form,\n#wysiwyg,\n#preview,\n#previewArea {\n\theight: 100%;\n\t/*CONF-41035*/\n}\n\n#content.edit {\n\tdisplay: table-cell;\n}\n\n.contenteditor #header-precursor > div,\n.contenteditor .cell {\n\tdisplay: table-cell;\n\t/* Needed to ensure that elements will appear below it when scrolling */\n}\n\n.contenteditor #header-precursor,\n.contenteditor #header-precursor .cell {\n\tz-index: 3;\n\tposition: relative;\n\tbackground: var(--ds-surface, #ffffff);\n}\n\n#main.active-preview .edit + br.clear {\n\tdisplay: none;\n}\n\n.contenteditor #header .cell,\n.contenteditor #header-precursor .cell {\n\tbox-sizing: border-box;\n\tpadding: 0 0.75em;\n}\n\n.contenteditor #main {\n\tborder: 0 !important;\n}\n\n#wysiwyg iframe,\n#preview iframe {\n\theight: 100%;\n\twidth: 100%;\n\tborder: 0;\n\tpadding: 0;\n\tmargin: 0;\n}\n\n.grouped ul,\n.grouped ol {\n\tmargin: 0;\n\tpadding-left: 0;\n}\n\n.aui-toolbar .grouped .grouped-dropdown-item {\n\tbackground: transparent;\n\tborder-top: 1px solid var(--ds-border, #ddd);\n\tmargin-top: 3px;\n\tpadding-top: 3px;\n\tpadding-bottom: 3px;\n\theight: auto;\n\tclear: both;\n}\n\n.aui-toolbar .aui-dropdown.grouped .grouped-dropdown-item:hover,\n.aui-toolbar .aui-dropdown.grouped .grouped-dropdown-item.active,\n.aui-toolbar .aui-dropdown.grouped .grouped-dropdown-item.active a {\n\tbackground: transparent;\n}\n\n.aui-toolbar .grouped .grouped-dropdown-item:first-child {\n\tborder-top: 0;\n\tpadding-top: 0;\n}\n\n.grouped span {\n\tdisplay: inline-block;\n\tpadding: 0 0.5em;\n\tmargin-top: 4px;\n\t/* avoid inappropriate hover effect */\n}\n\n.grouped .grouped-dropdown-item:hover,\n.grouped .grouped-dropdown-item.active {\n\tbackground: transparent;\n\t/* END exploratory pattern for grouped dropdowns */\n\t/* CSS from here on is implementation-specific */\n}\n\n#rte-savebar .loading {\n\tbackground: transparent url(../assets/icons/wait.gif) 50% 50% no-repeat;\n\ttext-indent: -9999px;\n\toverflow: hidden;\n\twidth: 25px;\n\theight: 25px;\n\tvisibility: hidden;\n\t/* hidden, but affecting layout by default. js handles further show/hide */\n\t/* Source editor styles */\n}\n\n#editor-html-source {\n\tborder: none;\n\toverflow-y: hidden;\n\twidth: 100%;\n\theight: 100%;\n}\n\n#editor-html-source-container {\n\tmargin-bottom: 40px;\n\t/* Editor toolbar and icons */\n\t/* TODOXHTML look at this stuff again    */\n}\n\n#previewArea iframe {\n\tborder: none;\n\tmargin: 0;\n\twidth: 100%;\n\toverflow-x: hidden;\n}\n\n.comment #previewArea {\n\tpadding: 1px;\n}\n\n.comment #previewArea iframe {\n\toverflow: hidden;\n}\n\n#rte-toolbar {\n\tfont-size: 0;\n\twidth: 100%;\n\tline-height: 1;\n\tborder-bottom: 1px solid var(--ds-border, #ccc);\n\tmargin: 0;\n\tpadding: 0;\n\tbackground-color: var(--ds-surface-sunken, #f5f5f5);\n\tpadding-top: 7px;\n}\n\n#rte-toolbar .aui-buttons {\n\tborder-left: 1px solid var(--ds-border, #cccccc);\n\tpadding-left: 3px;\n\tmargin-left: 0;\n}\n\nbody[data-aui-version='6.1.4-SNAPSHOT'] #rte-toolbar .aui-buttons .aui-button ~ .aui-button:active,\nbody[data-aui-version='6.1.4-SNAPSHOT'] #rte-toolbar .aui-buttons .aui-button ~ .aui-button:focus {\n\tmargin-left: 0;\n}\n\n.contenteditor #rte-toolbar {\n\tz-index: 2;\n\tposition: relative;\n}\n\n#rte-toolbar .aui-toolbar2-primary {\n\tmargin: 0 114px 0 10px;\n}\n\n.contenteditor #rte-toolbar .aui-toolbar2-primary {\n\tmargin-right: 16px;\n}\n\n#toolbar #rte-toolbar .aui-buttons {\n\tmargin-right: 3px;\n}\n\n#toolbar .aui-buttons + .aui-buttons {\n\tmargin-left: 0;\n}\n\n#toolbar #rte-toolbar .aui-toolbar2-primary .aui-buttons.no-separator {\n\tmargin-right: 2px;\n\tmargin-left: -2px;\n}\n\n#rte-toolbar .aui-toolbar2-secondary .aui-buttons,\n#rte-toolbar .aui-buttons.no-separator,\n#rte-toolbar .aui-buttons:first-child,\n#rte-toolbar .aui-buttons.close {\n\tborder-left: none;\n\tpadding-left: 0;\n}\n\n#rte-toolbar .disabled,\n#rte-toolbar .toolbar-contextual.disabled,\n#rte-toolbar .toolbar-item.disabled,\n#rte-toolbar-row-default .aui-button[disabled] .icon {\n\tcolor: var(--ds-icon-disabled, #707070);\n\topacity: 0.5;\n\tcursor: not-allowed;\n}\n\n#rte-toolbar .disabled a,\n#rte-toolbar .disabled span,\n#rte-toolbar .disabled button,\n#rte-toolbar .disabled div,\n#rte-toolbar .disabled li {\n\tcursor: not-allowed !important;\n\t/* When toolbar is disabled jquery.fadeTo(0.5) is executed. This ensures the [disabled]\n     icons don't compound the opacity changes */\n}\n\n#rte-toolbar-row-default.disabled .aui-button[disabled] .icon {\n\topacity: 1;\n}\n\n#rte-savebar {\n\tdisplay: block;\n\tmargin: 0;\n\tborder-top: 1px solid var(--ds-border, #ccc);\n\tbackground-color: var(--ds-surface-sunken, #f5f5f5);\n\tpadding: 5px 10px 0px 0;\n\tbox-shadow: none;\n}\n\n#rte-savebar #rte-spinner {\n\twidth: 16px;\n\theight: 18px;\n\tline-height: 20px;\n\tpadding: 0;\n\tmargin-top: 4px;\n}\n\n#rte-savebar .minor-edit label {\n\tcolor: var(--ds-text, #000);\n\tfont-weight: normal;\n}\n\n#rte-savebar #rte-button-cancel:not(.rte-button-cancel-shared-drafts),\n#rte-savebar #rte-button-revert {\n\tborder: 0;\n\tpadding: 1px;\n\tpadding-right: 0;\n}\n\n#rte-savebar .toolbar-split-row {\n\tfont-size: 11px;\n\tcolor: var(--ds-text-subtle, #666);\n\tmargin: 0;\n}\n\n#rte-savebar label {\n\tfont-size: 14px;\n\tmargin-right: 5px;\n\tline-height: 30px;\n}\n\n#rte-savebar .aui-buttons {\n\tmargin-right: 10px;\n\tmargin-left: 0;\n}\n\n#rte-savebar .save-button-container {\n\tfloat: left;\n\twhite-space: nowrap;\n\tpadding-left: 0;\n\tmargin-right: 10px;\n}\n\n#rte-savebar .aui-icon-wait {\n\t/* text wrapper for spinner */\n\tbackground-repeat: no-repeat;\n\tbackground-position: 0 3px;\n\tdisplay: block;\n}\n\n#rte-savebar .toolbar-split {\n\tline-height: 1;\n}\n\n#rte-savebar .hints {\n\tmargin-bottom: 0;\n}\n\n#rte-savebar .minor-edit,\n#rte-savebar .rte-toolbar-comment {\n\tpadding: 0;\n}\n\n#rte-savebar .minor-edit {\n\tmargin-top: 1px;\n}\n\n#rte-savebar-tinymce-plugin-point {\n\tfont-size: 14px;\n\tfloat: left;\n}\n\n#rte-savebar-tinymce-plugin-point .toolbar-item {\n\tfloat: none;\n\tmargin-left: 10px;\n}\n\n#rte-savebar .minor-edit input,\n#versionComment {\n\tposition: relative;\n}\n\n#rte-toolbar .toolbar-contextual {\n\tdisplay: block;\n\tbackground-color: var(--ds-surface-sunken, #f5f5f5);\n}\n\n#toolbar #rte-toolbar .toolbar-contextual .aui-buttons.close .icon-close {\n\theight: 16px;\n\twidth: 16px;\n}\n\n#rte-toolbar .toolbar-contextual .aui-buttons.close .aui-button {\n\tborder: 0;\n\tbackground: transparent;\n\tbox-shadow: none;\n\tpadding: 0;\n}\n\n#rte-toolbar .aui-toolbar2-secondary ul.aui-buttons:last-child {\n\tmargin-right: 0;\n}\n\n#rte-button-insert-table:focus {\n\toutline: none;\n}\n\n#rte-button-insert-table,\n#rte-button-insert,\n#rte-button-insert-template {\n\tpadding: 0 10px;\n}\n\n#toolbar-group-watch-page-after-comment {\n\tmargin: 0;\n\t/* Remove the margin here so we can use line height to position it. */\n}\n\n#rte-button-preview,\n#rte-button-publish,\n#rte-button-cancel,\n#rte-button-edit {\n\tline-height: 20px;\n}\n\n#rte-button-preview,\n#rte-button-cancel.rte-button-cancel-shared-drafts,\n#rte-button-edit {\n\tmin-width: 72px;\n}\n\n#rte-button-preview.rte-button-preview-shared-drafts {\n\tmin-width: inherit;\n}\n\n#rte-button-cancel.rte-button-cancel-shared-drafts {\n\tpadding: 4px 10px;\n}\n\n#rte-toolbar-row-searchreplace {\n\tpadding: 3px 0 0 10px;\n\tmargin-left: 0;\n\tdisplay: block;\n}\n\n#toolbar #rte-toolbar-row-searchreplace.toolbar-contextual .aui-buttons {\n\tmargin-left: 0;\n\tmargin-right: 3px;\n}\n\n#toolbar #rte-toolbar-row-searchreplace.toolbar-contextual .aui-buttons.no-separator {\n\tmargin-left: 10px;\n}\n\n#rte-toolbar-row-searchreplace .toolbar-group label {\n\tmargin-right: 4px;\n\tmargin-left: 10px;\n\tfont-size: 14px;\n}\n\n#rte-toolbar-row-searchreplace .aui-buttons .toolbar-item > label {\n\tline-height: 20px;\n\tfont-size: 14px;\n\tmargin-left: 20px;\n\tmargin-right: 10px;\n}\n\n#rte-toolbar-row-searchreplace .aui-buttons .toolbar-item:first-child > label {\n\tmargin-left: 0;\n}\n\n#rte-toolbar-row-searchreplace .aui-buttons .toolbar-item > input {\n\twidth: auto;\n}\n\n#search-toolbar-replace-text {\n\tmargin-right: 10px;\n}\n\n#rte-toolbar .toolbar-splitbutton .aui-dd-parent .aui-dd-trigger {\n\tpadding: 0 2px;\n}\n\n#rte-toolbar .toolbar-splitbutton .aui-dd-parent .aui-dd-trigger {\n\tpadding: 0 2px;\n\t/* partition off a tiny space in the top right of the toolbar to place the help button group */\n\t/* This overrides the toolbar split style in AUI 3.2.1 */\n}\n\n#rte-toolbar .toolbar-split-right {\n\tfloat: none;\n\tposition: absolute;\n\tright: 0;\n\ttop: 10px;\n\tmax-width: 80px;\n}\n\n#rte-toolbar .toolbar-split-left {\n\tmargin-right: 80px;\n}\n\n#savebar-container ul li.toolbar-item {\n\ttext-align: center;\n\t/* Required for button alignment in IE */\n\t/* Full screen editor styles */\n}\n\n.editor-fullheight {\n\theight: 100%;\n\t/* CONF-28415 */\n}\n\n#wysiwyg .mceIframeContainer,\n#wysiwyg table.mceLayout {\n\tborder: 0;\n\t/* Set dropdown links to block to make them full width */\n}\n\n#toolbar .aui-dropdown a {\n\tdisplay: block;\n\t/* TODOXHTML: change vms so this stuff simply isn't rendered on edit screen. */\n}\n\nbody.contenteditor #footer,\nbody.contenteditor #sidebar-container {\n\tdisplay: none;\n}\n\n#draft-status {\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n\tcolor: var(--ds-text-subtle, #707070);\n\tfont-size: 12px;\n\tline-height: 12px;\n\tpadding: 8px 0 0 10px;\n\tmax-width: 240px;\n}\n\n#draft-status a:hover,\n#draft-status a:active,\n#draft-status a:visited,\n#draft-status a:link {\n\tcolor: var(--ds-link-pressed, #707070);\n\t/* RTE hints and hint buttons */\n}\n\n.hints a:hover,\n.hints a:active,\n.hints a:visited,\n.hints a:link {\n\ttext-decoration: none;\n\toutline: none;\n}\n\n.hints {\n\tmargin: 0 0 10px 0;\n\t/* Confluence RTE Toolbar Icons */\n}\n\n#rte-button-color {\n\tborder-right: 0;\n\tmargin-right: 0;\n\t-moz-border-radius: 3px 0 0 3px;\n\t-webkit-border-radius: 3px 0 0 3px;\n\tborder-radius: 3px 0 0 3px;\n}\n\n#rte-button-color .selected-color {\n\tbackground: var(--ds-surface, #fff);\n\tborder: 1px solid var(--ds-border-selected, #ddd);\n\tborder-radius: 2px;\n\twidth: 14px;\n\theight: 2px;\n\tmargin: 18px 0 0 0;\n\tdisplay: block;\n}\n\n#rte-button-color .selected-color span {\n\twidth: 14px;\n\theight: 2px;\n\tmargin: 0;\n\tpadding: 0;\n}\n\n#rte-button-color .icon-textcolor {\n\tmargin-top: 2px;\n\t/* adjust padding to let the dropdown menus breathe */\n}\n\n#format-dropdown #format-dropdown-display {\n\tpadding: 0 10px 0 10px;\n}\n\n#format-dropdown #format-dropdown-display span.dropdown-text {\n\tfont-size: 12px;\n\tmin-width: 70px;\n\t/* covers maximum expected i18n text width to avoid drop down flickering */\n}\n\n#format-dropdown .aui-dropdown li {\n\theight: auto;\n\tpadding: 0;\n}\n\n#format-dropdown .aui-dropdown a {\n\tpadding: 6px 50px 6px 10px;\n}\n\n#format-dropdown .aui-dropdown .mce_h1 a,\n#format-dropdown .aui-dropdown .mce_h2 a,\n#format-dropdown .aui-dropdown .mce_h3 a,\n#format-dropdown .aui-dropdown .mce_h4 a {\n\tpadding: 0.4em 50px 0.5em 10px;\n}\n\n#insert-menu .aui-dropdown .icon {\n\tbackground-position: 0 0;\n\tbackground-repeat: no-repeat;\n\tbackground-color: transparent;\n\tdisplay: inline-block;\n\theight: 16px;\n\tpadding: 0;\n\tmargin: 1px 4px 0 0;\n\ttext-indent: -9999em;\n\twidth: 16px;\n}\n\n#pagelayout-menu .aui-dropdown a,\n#more-menu .aui-dropdown a,\n#insert-menu .aui-dropdown a,\n#template-menu .aui-dropdown a {\n\tline-height: 19px;\n}\n\n#more-menu .aui-dropdown a {\n\tpadding: 4px 50px 4px 25px;\n}\n\n#template-menu .aui-dropdown a {\n\tpadding: 6px 50px 6px 10px;\n}\n\n#insert-menu .aui-dropdown a {\n\tpadding: 4px 50px 4px 8px;\n\tmargin: 0;\n}\n\n#more-menu .no-icon .icon {\n\tmargin: 0;\n}\n\n#pagelayout-menu .aui-dropdown {\n\tmin-width: 0;\n}\n\n#pagelayout-menu .aui-dropdown a {\n\tmin-width: 0;\n\tpadding: 2px 10px 2px 25px;\n}\n\n#pagelayout-menu .aui-dropdown li:first-child {\n\tpadding-top: 5px;\n}\n\n#pagelayout-menu .aui-dropdown li:last-child {\n\tpadding-bottom: 5px;\n}\n\n#pagelayout-menu .aui-dropdown .icon {\n\t/* pagelayout specific styles */\n\tpadding-left: 0;\n}\n\n#pagelayout-menu .aui-dropdown .icon-layout {\n\tfloat: none;\n\tdisplay: block;\n\t/* icon-only buttons */\n}\n\n.aui-toolbar .icon {\n\ttext-indent: -9999em;\n\twidth: 16px;\n\tfloat: left;\n\theight: 100%;\n\tdisplay: inline-block;\n\tbackground: transparent 0 0 no-repeat;\n}\n\n#rte-savebar .aui-button-primary {\n\tpadding: 4px 10px;\n}\n\n#rte-toolbar .aui-button .dropdown-text {\n\tfloat: left;\n\t/* genuine AUI override */\n}\n\n.aui-toolbar .aui-dd-parent .aui-dropdown li {\n\tpadding: 0;\n\t/* overriding an AUI override until we can remove the override. no, really. */\n}\n\nbody .aui-toolbar .aui-dd-parent .aui-dropdown li a {\n\tcolor: var(--ds-text, #333);\n\tpadding: 4px 10px;\n\t/* TODOXHTML should probably get better consideration */\n}\n\n.aui-toolbar .aui-dd-parent .aui-dropdown li a:link {\n\tcolor: var(--ds-link, #333);\n}\n\n.aui-toolbar .aui-dd-parent .aui-dropdown li a:focus,\n.aui-toolbar .aui-dd-parent .aui-dropdown li a:hover,\n.aui-toolbar .aui-dd-parent .aui-dropdown li a:active,\n.aui-toolbar .aui-dd-parent .aui-dropdown li.active {\n\tbackground-color: var(--ds-surface-hovered, #f2f2f2);\n\tcolor: var(--ds-text, #333);\n\t/* end override */\n}\n\nform.aui.editor {\n\tmargin-top: 0px;\n\t/* TODOXHTML: remove the original competing style */\n}\n\n#format-dropdown li.mce_formatPreview.mce_blockquote a {\n\tborder-left: 0;\n\t/* Title styles */\n}\n\n#editor-precursor {\n\tbackground-color: var(--ds-surface-hovered, #f5f5f5);\n}\n\n#editor-precursor .cell {\n\tdisplay: block;\n\tpadding-bottom: 10px;\n\twidth: 100%;\n\tposition: relative;\n}\n\n.active-preview #editor-precursor .cell {\n\tborder-bottom: 1px dashed transparent;\n}\n\n#editor-precursor #breadcrumbs {\n\tpadding-left: 10px;\n\tdisplay: inline-block;\n\tmargin-top: 20px;\n\tmargin-bottom: 10px;\n}\n\n#editor-precursor #draft-status-lozenge {\n\tposition: relative;\n\ttop: -3px;\n\ttext-decoration: none;\n}\n\n#editor-precursor #editor-messages {\n\tmargin: 0 10px;\n\t/* CONF-32021 Remove aui style causing editor messages to appear too close to the page title input field */\n}\n\n#editor-precursor .aui-message:first-child {\n\tmargin-top: 10px;\n}\n\n#content-title {\n\tmax-width: 100%;\n\tmargin: 0;\n\tmin-height: 32px;\n\tline-height: 30px;\n\tpadding: 0;\n\toutline: none;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n\tbackground: none;\n\tborder: none !important;\n\t/* Applying !important to beat an AUI override that is necessary for overriding Spinner2 (3rd party) border */\n\tbox-shadow: none;\n\tdisplay: inline-block;\n\tfont-size: 28px;\n\theight: 32px;\n\twidth: 100%;\n\t/* placeholder styles, don't group them */\n}\n\n#content-title::-webkit-input-placeholder {\n\tcolor: var(--ds-text, #999999);\n}\n\n#content-title:-moz-placeholder {\n\tcolor: var(--ds-text, #999999);\n}\n\n#content-title::-moz-placeholder {\n\tcolor: var(--ds-text, #999999);\n}\n\n#content-title:-ms-input-placeholder {\n\tcolor: var(--ds-text, #999999);\n}\n\n#content-title-div {\n\tpadding: 0px 30px 0 10px;\n\tfont-size: 24px;\n\tline-height: normal;\n\tfont-weight: bold;\n\tmargin-top: 0px;\n}\n\n#content-title-div .field-group {\n\tpadding: 0;\n}\n\n#content-title-div .error {\n\t/* We need to sytle it as it's not in an AUI form */\n\tfont-weight: bold;\n\tcolor: var(--ds-text-danger, #cc0000);\n\tbackground-color: var(--ds-surface, #fff);\n\tpadding-top: 5px;\n}\n\n.editor.aui #all-messages {\n\tpadding: 0 10px 0 10px;\n}\n\n.contenteditor #main-header,\n#comments-section #editor-precursor,\n#comments-section #editor-notifications-container,\n#main.active-preview.active-preview #editor-notifications-container,\n#main.active-preview #editor-messages,\n#main.active-preview #editpageform > div#toolbar,\n#main.active-preview #content-title-div {\n\tdisplay: none;\n}\n\n.contenteditor .active-preview #main-header {\n\tdisplay: block;\n}\n\n.quick-comment-container #editor-messages .aui-message.error {\n\tmargin: 0 0 10px 0;\n}\n\n#editor-notification-container {\n\tdisplay: table-row;\n\tposition: absolute;\n\tbottom: 100px;\n\tright: 25px;\n\twidth: 300px;\n\tz-index: 5;\n}\n\n.contenteditor #editor-notifications-container {\n\tleft: 0;\n\tmargin: 0 auto;\n\tmax-width: 880px;\n\tposition: absolute;\n\tright: 0;\n\ttop: 10px;\n\twidth: 100%;\n\tz-index: 2;\n}\n\n.contenteditor #full-height-container.active-preview .aui-message {\n\tmargin: 20px 20px 0 20px;\n}\n\n.contenteditor #editor-notifications-container #all-messages,\n.contenteditor #editor-notifications-container #heartbeat-div,\n.contenteditor #editor-notifications-container #editor-messages {\n\twidth: 100%;\n\tpadding: 0;\n}\n\n.contenteditor #editor-notifications-container #all-messages .aui-message,\n.contenteditor #editor-notifications-container #heartbeat-div .aui-message,\n.contenteditor #editor-notifications-container #editor-messages .aui-message {\n\tmargin: 10px 0px;\n\t-webkit-box-shadow: var(--ds-shadow-raised, 0px 3px 6px 0px rgba(0, 0, 0, 0.2));\n\t-moz-box-shadow: var(--ds-shadow-raised, 0px 3px 6px 0px rgba(0, 0, 0, 0.2));\n\tbox-shadow: var(--ds-shadow-raised, 0px 3px 6px 0px rgba(0, 0, 0, 0.2));\n}\n\n.contenteditor #editor-precursor {\n\tposition: absolute;\n\tz-index: 1;\n\twidth: 100%;\n\tbackground: none;\n\tpadding: 0px;\n}\n\n#toolbar #more-menu .dd-allocated,\n#toolbar #more-menu .dd-allocated .aui-button {\n\tmargin-left: 0;\n}\n\n.aui-toolbar .toolbar-split-captcha .toolbar-group {\n\tfloat: right;\n}\n\n.aui-toolbar .captcha {\n\tpadding: 0;\n\twidth: auto;\n\ttext-align: right;\n}\n\n.aui-toolbar .captcha .aui-message-warning,\n.aui-toolbar #captcha-response {\n\tclear: both;\n}\n\n.aui-toolbar .captcha-image {\n\tmargin: 7px 3px;\n}\n\n.aui-toolbar .captcha-image,\n.aui-toolbar #captcha-response {\n\tfloat: right;\n}\n\n#rte-toolbar li.disabled:not(.active),\n#rte-toolbar button.disabled:not(.active),\n#rte-toolbar .disabled:focus button:not(.active),\n#rte-toolbar .disabled:hover button:not(.active),\n#rte-toolbar .disabled:active button:not(.active),\n#rte-toolbar .disabled:focus a:not(.active),\n#rte-toolbar .disabled:hover a:not(.active),\n#rte-toolbar .disabled:active a:not(.active) {\n\tbox-shadow: none !important;\n\tbackground: none !important;\n\tborder-color: transparent !important;\n\t/* CONFDEV-4468 - Copied from tiny_mce/themes/advanced/skins/default/ui.css */\n}\n\n#wysiwyg .defaultSkin .mceBlocker {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\tz-index: 1000;\n\topacity: 0.5;\n\t-ms-filter: 'alpha(opacity=50)';\n\tfilter: alpha(opacity=50);\n\tbackground: var(--ds-surface, #fff);\n}\n\n#wysiwyg .defaultSkin .mceProgress {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\tz-index: 1001;\n\tbackground: url(data:image/gif;base64,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)\n\t\ttop left no-repeat;\n\twidth: 32px;\n\theight: 32px;\n\tmargin: -16px 0 0 -16px;\n\t/* Table Picker */\n}\n\n#table-picker-container .table-picker-box {\n\toverflow: hidden;\n\tborder: 1px solid var(--ds-border, #ccc);\n\tpadding: 6px;\n\tbackground-color: var(--ds-surface, #fff);\n\tcursor: pointer;\n}\n\n#table-picker-container .table-picker-background {\n\tposition: relative;\n}\n\n#table-picker-container .picker {\n\toverflow: hidden;\n\tbackground-repeat: repeat;\n\tposition: absolute;\n}\n\n#table-picker-container .picker.heading {\n\theight: 18px;\n}\n\n#table-picker-container .table-picker-box .desc {\n\toverflow: hidden;\n\tfont-family: helvetica;\n\tfont-size: 12px;\n\tdisplay: block;\n\ttext-align: center;\n\tfont-weight: bold;\n\twidth: 100%;\n\tmargin: 0;\n\tposition: absolute;\n\tbottom: 0;\n\tleft: 0;\n\theight: 20px;\n}\n\n#table-picker-container {\n\tposition: absolute;\n\tz-index: 10001;\n}\n\n#table-picker-backdrop {\n\tbackground-color: transparent;\n\tposition: fixed;\n\tpadding: 0;\n\tmargin: 0;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 10000;\n}\n\n#conflict-diffs {\n\tdisplay: table-cell;\n\tborder-top: 1px solid var(--ds-border, #ccc);\n\tborder-bottom: 1px solid var(--ds-border, #ccc);\n}\n\n#conflict-wrapper {\n\tmax-height: 300px;\n\toverflow: auto;\n}\n\n#conflict-wrapper > .aui-message {\n\tmargin: 10px;\n}\n\n#page-diffs {\n\tmargin: 0 10px;\n\tpadding: 10px 0;\n}\n\n#confluence-editor-discard-confirm-dialog .confluence-editor-discard-message span {\n\tbackground-image: url(../assets/emoticons/warning.png);\n\tbackground-position: 0.5em 50%;\n\tbackground-repeat: no-repeat;\n\tmargin: 0px;\n\tpadding-left: 28px;\n\tpadding-top: 0px;\n\t/* from master.css */\n}\n\n.hidden,\nli.hidden {\n\tdisplay: none !important;\n\tvisibility: hidden;\n}\n\n#page {\n\twidth: 100%;\n\theight: 100%;\n\tmargin: 0;\n\tpadding: 0;\n\t/* End from master.css */\n\t/* from default-theme.css */\n}\n\nhtml,\nbody {\n\theight: 100%;\n}\n\n#full-height-container {\n\theight: 100%;\n\twidth: 100%;\n\tposition: relative;\n}\n\n#full-height-container.active-preview {\n\tbackground-color: var(--ds-surface, #ffffff);\n\t/* End from default-theme.css */\n\t/* custom overrides for PDL */\n}\n\n#toolbar .aui-toolbar2-secondary {\n\tmargin-right: -6px;\n}\n\n#toolbar .aui-toolbar2-secondary .aui-button {\n\tpadding: 0 6px;\n}\n\n.aui-toolbar2 {\n\tbox-sizing: border-box;\n}\n\n.aui-toolbar2 .aui-toolbar2-primary {\n\tfloat: left;\n}\n\n.aui-toolbar2 .aui-toolbar2-secondary {\n\tposition: absolute;\n\ttop: 7px;\n\tright: 10px;\n}\n\n.aui-toolbar2 .toolbar-dropdown .icon-dropdown {\n\theight: 100%;\n}\n\n.aui-toolbar2 .aui-dd-parent > a.toolbar-trigger.aui-dd-trigger {\n\tposition: relative;\n\theight: 26px;\n\tline-height: 24px;\n\tfont-size: 12px;\n\tborder-top-right-radius: 3px;\n\tborder-bottom-right-radius: 3px;\n\ttext-shadow: none;\n\ttext-decoration: none;\n\t/* dropdown arrow */\n}\n\n.aui-toolbar2 .aui-dd-parent > a.toolbar-trigger.aui-dd-trigger:after {\n\tborder: 4px solid transparent;\n\tcontent: '';\n\theight: 0;\n\tleft: 100%;\n\t/* \"left\" + \"margin-left\" required because of webkit not working properly with \"right\" */\n\tmargin-left: -18px;\n\tmargin-top: -1px;\n\topacity: 0.8;\n\tposition: absolute;\n\ttop: 50%;\n\twidth: 0;\n\tborder-top-color: var(--ds-border, #333);\n\t/* Following rules target Insert table and Insert More styles */\n}\n\n#toolbar .aui-toolbar2 .aui-buttons.no-separator .aui-dd-parent > a.aui-dd-trigger {\n\tpadding-right: 5px;\n}\n\n#toolbar .aui-toolbar2 .aui-buttons.no-separator .aui-dd-parent > a.aui-dd-trigger:after {\n\tmargin-left: -15px;\n}\n\n.aui-toolbar2 .aui-dd-parent > a.aui-dd-trigger:hover:after {\n\topacity: 1;\n}\n\n.aui-toolbar2 .aui-dd-parent > a.aui-dd-trigger:active,\n.aui-toolbar2 .toolbar-dropdown.active .aui-dd-parent > a.aui-dd-trigger,\n.aui-toolbar2 .aui-dd-parent.active > a.aui-dd-trigger {\n\tbackground-image: none;\n\tbackground-color: var(--ds-background-input-pressed, #f2f2f2);\n\tbox-shadow: var(--ds-shadow-raised, inset 0 3px 6px rgba(0, 0, 0, 0.1));\n\ttext-shadow: none;\n\ttext-decoration: none;\n\t/*\n     Ideally can remove these overrides when this issue is resolved\n     https://ecosystem.atlassian.net/browse/AUI-949\n     */\n}\n\n.aui-toolbar2 .aui-dropdown,\nbody.edit .aui-dialog .aui-dropdown,\nbody.create .aui-dialog .aui-dropdown {\n\tbackground-color: var(--ds-surface, #fff);\n\tborder: 1px solid var(--ds-border, #ccc);\n\tborder-bottom-left-radius: 3px;\n\tborder-bottom-right-radius: 3px;\n\tbox-shadow: var(--ds-shadow-raised, 0 3px 6px rgba(0, 0, 0, 0.2));\n}\n\n.aui-toolbar2 .aui-dropdown a.item-link,\n.aui-toolbar2\n\t.aui-dropdown\n\ta.item-link:focus\n\t.aui-toolbar2\n\t.aui-dropdown\n\ta.item-link:hover\n\t.aui-toolbar2\n\t.aui-dropdown\n\ta.item-link:active {\n\ttext-decoration: none;\n\tfont-size: 14px;\n}\n\n.aui-buttons li.toolbar-dropdown:first-child {\n\tborder-top-left-radius: 3px;\n\tborder-bottom-left-radius: 3px;\n\tborder-left-width: 1px;\n\tborder-left-color: var(--ds-border-bold, #ccc);\n}\n\n#rte-toolbar .toolbar-item,\n#rte-toolbar .toolbar-item > a.toolbar-trigger {\n\theight: 26px;\n}\n\n#rte-toolbar .toolbar-item:link,\n#rte-toolbar .toolbar-item > a.toolbar-trigger:link,\n#rte-toolbar .toolbar-item:visited,\n#rte-toolbar .toolbar-item > a.toolbar-trigger:visited,\n#rte-toolbar .toolbar-item:hover,\n#rte-toolbar .toolbar-item > a.toolbar-trigger:hover,\n#rte-toolbar .toolbar-item:focus,\n#rte-toolbar .toolbar-item > a.toolbar-trigger:focus,\n#rte-toolbar .toolbar-item:active,\n#rte-toolbar .toolbar-item > a.toolbar-trigger:active {\n\ttext-decoration: none;\n\tcolor: var(--ds-text, #333);\n}\n\n.aui-toolbar2 li.aui-button {\n\tdisplay: inline-block;\n\tpadding: 0 10px;\n\tfloat: none;\n\tline-height: 30px;\n}\n\n.aui-toolbar2 li.aui-button a.toolbar-trigger {\n\tpadding: 0;\n\tmargin: 0;\n}\n\n#format-dropdown-display-menu li > a {\n\tmargin-left: 2px;\n}\n\n#table-more-settings h2 {\n\tpadding-bottom: 10px;\n}\n\n#rte-savebar .aui-button-link:hover {\n\ttext-decoration: none;\n}\n\n#rte-savebar .aui-button span.icon ~ span.trigger-text,\n#rte-toolbar .aui-button span.icon ~ span.trigger-text,\n#rte-toolbar .aui-button span.icon ~ span.dropdown-text,\n#property-panel .aui-button span.icon ~ span.panel-button-text {\n\tpadding-left: 3px;\n}\n\n#rte-toolbar .aui-button,\n#rte-savebar .aui-button {\n\tmargin-top: 0;\n}\n\n#rte-savebar.aui-toolbar2 .aui-button {\n\tmargin-top: 0px;\n}\n\n#editor-precursor .aui-toolbar2 .aui-button {\n\tpadding: 0 6px;\n}\n\n#editor-precursor .aui-toolbar2 {\n\tpadding-left: 10px;\n}\n\n.aui-page-panel.active-preview #editor-precursor .aui-toolbar2 {\n\t/* Here we hide the breadcrumb buttons when in the editor preview mode. */\n\tdisplay: none;\n}\n\n.aui-message .aui-icon {\n\tbackground-position: center;\n}\n\n#rte-toolbar input,\n#rte-savebar input,\n#update-page-restrictions-dialog input {\n\tfont-size: 14px;\n}\n\n#rte-toolbar-row-searchreplace .aui-buttons {\n\tmargin-top: 0;\n}\n\n#rte-toolbar .aui-dropdown {\n\tz-index: 4001;\n\t/* Higher than property panels */\n\t/* End custom overrides for PDL */\n\t/* These containers need to be positioned above the page title and breadcrumbs in the editor,\n     so that they don't re-appear above the global header as the editor content is scrolled */\n}\n\n#editpageform > #anonymous-warning {\n\tdisplay: none;\n}\n\n#comments-section #anonymous-warning {\n\tmargin-top: 0;\n\tmargin-bottom: 10px;\n}\n\n.contenteditor #pas-announcement {\n\tdisplay: block;\n\tposition: relative;\n\topacity: 1;\n}\n\n.contenteditor #header {\n\tz-index: 3;\n\tposition: relative;\n}\n\n.contenteditor #conflict-diffs {\n\tz-index: 2;\n\tposition: relative;\n\tbackground: var(--ds-surface, #ffffff);\n}\n\n#rte-toolbar {\n\t/*Relative resize table*/\n}\n\n#rte-toolbar ul.table-mode-list {\n\tlist-style: none;\n\tmargin: 0;\n\tpadding: 5px 0;\n}\n\n#rte-toolbar ul.table-mode-list .item-link {\n\tpadding-right: 20px;\n}\n\n#rte-toolbar ul.table-mode-list .dropdown-item {\n\tline-height: 18px;\n}\n\n#table-mode-picker a.toolbar-trigger.aui-button {\n\tpadding: 0 10px;\n\tcolor: var(--ds-text, #333);\n}\n\n#table-mode-picker.active .toolbar-trigger.aui-button {\n\tborder-color: var(--ds-border, #ccc);\n}\n\n.quit-editor-dialog .tipsy-inner {\n\ttext-align: left;\n\tmax-width: 220px;\n}\n\n#quit-editor-dialog button.disabled {\n\ttext-decoration: none;\n\toutline: none;\n}\n\n#quit-editor-dialog .legend {\n\tmargin-bottom: 15px;\n}\n\n#quit-editor-dialog .legend .legend-title {\n\tfont-weight: bold;\n}\n\n#quit-editor-dialog .legend span {\n\tpadding: 5px;\n}\n\n#quit-editor-dialog .diff-context-placeholder {\n\tbackground: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQCAYAAAAiYZ4HAAAABGdBTUEAALGPC/xhBQAAARBJREFUKBV9kbuuRUAUhteISyVRaBQUKu//KhoitBKFEBTitv3rnCWzx8mZZFxmvv8y0PXHOI7jKsvyGobhtWuRMc7zpKqqaJomquuaxnH8Ir4EAs/zTEopuu1fokegw47jUJqmFATBS6RQ0oSTJCHXdblK27Z0n4UTYaL6vr+6riPUgLMOS3ldZDdNw+smbFk/bZEeRREzSLJ936d1XSmO46cGYNu2Gdr3nXSRWpblkmjcBS6KgpezLCMR8T4+Hya//DoDRiomnpEmFS18a0zdGaDneTxNkdq27akkzoBRBcNcewTmhn5ofU/lec4JUgPOAnPEfcGhRWQB/A+GCAYwQlV1/0VOCMPw5SwJckfSB4/U/WAIKs/PAAAAAElFTkSuQmCC')\n\t\trepeat-x;\n\tbackground-size: 6px;\n\theight: 10px;\n}\n\n#quit-editor-dialog .aui-button {\n\tdisplay: none;\n}\n\n#quit-editor-dialog .contributor-list {\n\tlist-style: none;\n\tpadding-left: 0px;\n\tmargin-top: 13px;\n\tmax-height: 160px;\n\toverflow-y: auto;\n}\n\n#quit-editor-dialog .contributor-list li {\n\tfloat: left;\n\twidth: 50%;\n}\n\n#quit-editor-dialog .contributor-avatar {\n\tdisplay: table-cell;\n\tvertical-align: middle;\n\tpadding: 4px 0;\n}\n\n#quit-editor-dialog .contributor-avatar img {\n\tborder-radius: 3px;\n\theight: 32px;\n}\n\n#quit-editor-dialog .contributor-avatar:not(.active) {\n\t-webkit-filter: grayscale(100%);\n\tfilter: grayscale(100%);\n\topacity: 0.7;\n}\n\n#quit-editor-dialog .contributor-name {\n\tpadding: 0 10px;\n\tfont-weight: bold;\n\tdisplay: table-cell;\n\tvertical-align: middle;\n}\n\n#quit-editor-dialog .contributor-detail {\n\tdisplay: table-cell;\n\tpadding: 0 10px;\n}\n\n#quit-editor-dialog .contributor-detail-name {\n\tfont-weight: bold;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\tdisplay: block;\n\twidth: 200px;\n\toverflow: hidden;\n}\n\n#quit-editor-dialog .contributor-detail-last-modification {\n\tdisplay: inline-block;\n\tmargin: 0;\n\tfont-size: 13px;\n\tvertical-align: bottom;\n\t-webkit-filter: grayscale(100%);\n\tfilter: grayscale(100%);\n\topacity: 0.6;\n}\n\n.editor-block::after {\n\tbackground: var(--ds-background-neutral-subtle, #000);\n\topacity: 0.5;\n\tcontent: '';\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\tleft: 0;\n\tbottom: 0;\n\tz-index: 2;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
